import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";
import {EventsService} from "../../events.service";

@Component({
  selector: 'app-ramdan2022',
  templateUrl: './ramdan2022.component.html',
  styleUrls: ['./ramdan2022.component.scss']
})
export class Ramdan2022Component implements OnInit {

  constructor( private titleService: Title , public eventService:EventsService) {
    this.titleService.setTitle('ramadan-2022')
    this.eventService.getEvent('ramadan-2022').subscribe(res => {
      this.eventService.Games = res.games
    })
  }
  ngOnInit(): void {

  }

}
